import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core'
import { filter, first } from 'rxjs/operators'
import { TranslateService } from '@ngx-translate/core'

import { AddNoteDialogComponent } from '@shared/dialogs/add-note-dialog/add-note-dialog.component'
import { DialogService } from '@shared/dialogs/dialog.service'
import { NoteHistory } from '@shared/models/note.model'
import { AuthService } from '@app/modules/auth/auth.service'

@Component({
  selector: 'lin-note-list',
  templateUrl: './note-list.component.html',
  styleUrls: ['./note-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoteListComponent {
  @Input() isClient: boolean
  @Input() notesTitle: string
  @Input() noteText: string
  @Input() height = 200
  @Input() notesHistory: NoteHistory[]
  @Output() addNewNote = new EventEmitter<string>()
  @Output() deleteNote = new EventEmitter<number>()

  get currentUserEmail(): string {
    return this.authService.getCurrentUser().email
  }

  constructor(
    private readonly dialog: DialogService,
    private readonly translateService: TranslateService,
    private readonly authService: AuthService,
  ) {}

  addNote(): void {
    this.dialog
      .open(AddNoteDialogComponent, <string>this.translateService.instant('FIELDS.ADD_NEW_NOTE'))
      .afterClosed()
      .pipe(first())
      .subscribe((note: string) => this.addNewNote.emit(note))
  }

  onDeleteNote(noteId: string): void {
    this.dialog
      .confirm(<string>this.translateService.instant('DIALOGS.MESSAGES.DELETE_NOTE'))
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.deleteNote.emit(Number(noteId))
      })
  }
}
